import { Button } from "@/components/ui/baseUi/button"
import { InputContainer } from "@/components/ui/forms/inputContainer"
import { ProgramBundleTypeInput } from "@/components/ui/forms/programBundleTypeInput"
import { ProgramBundleVisibilityInput } from "@/components/ui/forms/programBundleVisibilityInput"
import { StandardInput } from "@/components/ui/forms/standardInput"
import { TextAreaInput } from "@/components/ui/forms/textareaInput"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { HUImageForm } from "@/modules/ui/components/huImageForm"
import { word } from "@modules/core/utils/i18n"
import { type ProgramBundleFormPageProps } from "@modules/programBundle/components/programBundleForm"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ArrowRight } from "lucide-react"

export function ProgramBundleFormFirstPage({
  formik,
  getFormErrorMessage,
  handleSubmit,
  isEdited,
  className,
  ...props
}: ProgramBundleFormPageProps) {
  const { hideSidebar } = useSidebar()

  return (
    <div className={cn("flex flex-col gap-6 pb-4", className)} {...props}>
      {/* TITLE */}
      <div className="flex flex-col">
        <Text fontStyle="BS" className="text-textDefault-caption">
          {word("programBundle.form.firstPage.step")}
        </Text>
        <Text fontStyle="HM" className="mt-4 text-textDefault-heading">
          {word("programBundle.form.firstPage.title")}
        </Text>
        <Text fontStyle="BM" className="mt-1 text-textDefault-heading">
          {word("programBundle.form.firstPage.subtitle")}
        </Text>
      </div>
      {/* COVER IMAGE */}
      <InputContainer error={getFormErrorMessage("image")} label={word("program.form.image.label")} isRequiredInput>
        <HUImageForm
          type="cover"
          setImage={(e) => {
            formik.setFieldValue("image", e)
          }}
          image={formik.values.image}
          placeHolder={{
            message: word("program.form.uploadImage.text1"),
          }}
        />
      </InputContainer>
      {/* TITLE */}
      <StandardInput
        label={word("offer.form.title.label")}
        name="name"
        isRequiredInput
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("name")}
        inputProps={{
          placeholder: word("offer.form.title.placeholder"),
        }}
      />
      {/* DESCRIPTION */}
      <TextAreaInput
        label={word("program.form.description.label")}
        name="description"
        isRequiredInput
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("description")}
        textareaProps={{
          placeholder: word("offer.form.description.placeholder"),
          rows: 4,
          className: "field-sizing-fixed",
        }}
      />
      {/* TYPE */}
      <ProgramBundleTypeInput
        label={word("programBundle.form.typeOfPrograms.label")}
        name="type"
        isRequiredInput={true}
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("type")}
        isSwitchEnabled={formik.values.programIds.length === 0 && !isEdited}
        className="mb-3 flex w-full flex-col"
      />
      {/* VISIBILITY */}
      <ProgramBundleVisibilityInput
        label={"Visibility"}
        name="visibility"
        isRequiredInput={true}
        getFieldProps={formik.getFieldProps}
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("visibility")}
        className="mb-3 flex w-full flex-col"
      />
      {/* NEXT BUTTON */}
      <div className="mt-5 mb-6 flex w-full flex-row gap-5">
        <Button variant="outline" size="lg" className="grow px-3 py-2" onClick={() => hideSidebar()}>
          {word("global.cancel")}
        </Button>
        <Button
          variant="primary"
          size="lg"
          className="grow px-3 py-2"
          onClick={() => {
            handleSubmit()
          }}
        >
          {word("global.next")}
          <ArrowRight />
        </Button>
      </div>
    </div>
  )
}
